import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './i18n';
import App from './App';

// Set API base URL from environment variable or production API host
const apiBaseURL = (process.env.REACT_APP_API_BASE_URL || 'https://api.vehiclesolution.co').replace(/\/+$/, '');
axios.defaults.baseURL = apiBaseURL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
